const options = {
    current: true,
    hover: false,
    parent: false
};
export default options;
